import { render, staticRenderFns } from "./PlatformMotive.vue?vue&type=template&id=3ab406a8&scoped=true&"
import script from "./PlatformMotive.vue?vue&type=script&lang=ts&"
export * from "./PlatformMotive.vue?vue&type=script&lang=ts&"
import style0 from "./PlatformMotive.vue?vue&type=style&index=0&id=3ab406a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab406a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
